import React from "react";
import { Navbar } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

import ProfileDropDown from "@/shared/components/header/ProfileDropDown";
import HeaderBrandLogoDropDown from "@/shared/components/header/HeaderBrandLogoDropDown";

const BootstrapNavbar = Navbar as React.ElementType;

// Styled component using the new MUI v7 styling system
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    display: "none",
  },
  color: theme?.palette?.primary?.main,
}));

const MainHeader = ({
  handleDrawerToggle,
}: {
  handleDrawerToggle?: () => void;
}) => {
  return (
    <>
      <BootstrapNavbar
        fixed="top"
        expand="lg"
        variant="light"
        className="main-header py-1"
      >
        <div className="d-flex justify-content-between px-sm-4 w-100">
          <StyledIconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </StyledIconButton>
          <HeaderBrandLogoDropDown />
          <div style={{ flexGrow: 1 }}></div>
          <ProfileDropDown />
        </div>
      </BootstrapNavbar>
    </>
  );
};

export default MainHeader;
